import { SET_CUSTOM_FIELD_1 } from 'actions';

export function setCustomField1(sourceType: string) {
  return { sourceType, type: SET_CUSTOM_FIELD_1 };
}
